import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentQuantumOfImpactDto extends EpimsBaseEntityDto {
  IncidentQuantumId: string;
  IncidentQuantumName: string;
  DistributorFactorValue: number;
  DistributorFactorName: string;
  SubscriptionUserId: string;
  Version: number;
}
